<mat-toolbar class="mat-elevation-z8">
    {{orderLog.description}}
</mat-toolbar>

<mat-dialog-content class="mt-3">

    <p>created: {{orderLog.created | date: 'yyyy-MM-dd HH:mm' }}</p>
    <p>createdBy: {{orderLog.createdBy}}</p>
    <p>log:</p>
    <p>{{orderLog.log}}</p>

</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>STÄNG</button>
</mat-dialog-actions>